
      import { lazy } from "react";

      export const MkdInput = lazy(() => import("./MkdInput"));
      